<template>
    <v-card-text class="mt-4">
        <v-row class="centrado">
            <v-flex xs12>
                <v-img
                        class="centrado ml-4 mr-4"
                        :src="require('../assets/intLogo.png')"
                        height="250px"
                        contain
                ></v-img>
            </v-flex>
            <div class="
                text-xs-center
                text-sm-center
                text-md-center
                text-lg-center
                text-xl-center">
                <br>
                <h2>{{$t('registro_exito')}}</h2>
                <h4>{{$t('msj_cerrar_pagina')}}</h4>
                <h4>{{$t('msj2_cerrar_pagina')}}</h4>
                <h4>{{$t('msj_cerrar_pagina_complemento')}}</h4>
            </div>
        </v-row>
    </v-card-text>
</template>

<script>
    export default {
        name: "registro_exito"
    }
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
